import { Injectable } from '@angular/core';
import { GenericViewDataModel } from '@osos/shared/api';
import { GenericViewPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { GenericViewsParserV1Service } from '../../parsers/generic-views-parser/generic-views-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class GenericViewsFactoryService extends FactoryBase<
  GenericViewDataModel,
  GenericViewPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: GenericViewsParserV1Service,
  ) {
    super(parserFactory);
    parserFactory.register(parser_v1);
  }

  createPresenterModel(model: GenericViewDataModel): GenericViewPresenterModel {
    const parser = this.getParser(
      GenericViewDataModel,
      GenericViewPresenterModel,
      model.specificationVersion || 1,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }

  createDataModel(presenter: GenericViewPresenterModel): GenericViewDataModel {
    const parser = this.getParser(
      GenericViewDataModel,
      GenericViewPresenterModel,
      presenter.specificationVersion || 1,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }
}
